import React, { PropsWithChildren } from "react";
import { SearchFieldLabel } from "../../components/label";

type SubsectionWithCheckboxesProps = {
    label: string;
    noMarginBottom?: boolean;
    name?: string;
};

export const SubsectionWithCheckboxes: React.FC<
    PropsWithChildren<SubsectionWithCheckboxesProps>
> = ({ label, noMarginBottom, name, children }) => {
    return (
        <div className={!noMarginBottom && "mb-9"}>
            <SearchFieldLabel name={name}>{label}</SearchFieldLabel>
            <div className="grid grid-cols-2 gap-y-1 gap-x-6 xl:grid-cols-4">
                {children}
            </div>
        </div>
    );
};
